import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var ContextMenuBuiltInItems = /** @class */ (function (_super) {
    __extends(ContextMenuBuiltInItems, _super);
    function ContextMenuBuiltInItems() {
        var _this = _super.call(this) || this;
        _this._save = true;
        _this._zoom = true;
        _this._quality = true;
        _this._play = true;
        _this._loop = true;
        _this._rewind = true;
        _this._forwardAndBack = true;
        _this._print = true;
        return _this;
    }
    Object.defineProperty(ContextMenuBuiltInItems.prototype, "save", {
        get: function () {
            return this._save;
        },
        set: function (val) {
            this._save = !!val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenuBuiltInItems.prototype, "zoom", {
        get: function () {
            return this._zoom;
        },
        set: function (val) {
            this._zoom = !!val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenuBuiltInItems.prototype, "quality", {
        get: function () {
            return this._quality;
        },
        set: function (val) {
            this._quality = !!val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenuBuiltInItems.prototype, "play", {
        get: function () {
            return this._play;
        },
        set: function (val) {
            this._play = !!val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenuBuiltInItems.prototype, "loop", {
        get: function () {
            return this._loop;
        },
        set: function (val) {
            this._loop = !!val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenuBuiltInItems.prototype, "rewind", {
        get: function () {
            return this._rewind;
        },
        set: function (val) {
            this._rewind = !!val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenuBuiltInItems.prototype, "forwardAndBack", {
        get: function () {
            return this._forwardAndBack;
        },
        set: function (val) {
            this._forwardAndBack = !!val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenuBuiltInItems.prototype, "print", {
        get: function () {
            return this._print;
        },
        set: function (val) {
            this._print = !!val;
        },
        enumerable: false,
        configurable: true
    });
    ContextMenuBuiltInItems.prototype.clone = function () {
        var items = new ContextMenuBuiltInItems();
        items._save = this._save;
        items._zoom = this._zoom;
        items._quality = this._quality;
        items._play = this._play;
        items._loop = this._loop;
        items._rewind = this._rewind;
        items._forwardAndBack = this._forwardAndBack;
        items._print = this._print;
        return items;
    };
    ContextMenuBuiltInItems.classInitializer = null;
    return ContextMenuBuiltInItems;
}(ASObject));
export { ContextMenuBuiltInItems };
